import React from 'react';
import { Helmet } from 'react-helmet-async';
import FantasyFootballHero from '../components/FantasyFootballHero';
import FantasyFootballNameGenerator from '../components/FantasyFootballNameGenerator';
import FantasyFootballFeatures from '../components/FantasyFootballFeatures';
import FantasyFootballHowItWorks from '../components/FantasyFootballHowItWorks';
import FantasyFootballTestimonials from '../components/FantasyFootballTestimonials';
import FantasyFootballGuide from '../components/FantasyFootballGuide';
import FantasyFootballSEOContent from '../components/FantasyFootballSEOContent';
import FantasyFootballFAQ from '../components/FantasyFootballFAQ';
import FantasyFootballCallToAction from '../components/FantasyFootballCallToAction';

export default function FantasyFootballPage() {
  return (
    <>
      <Helmet>
        <title>Fantasy Football Team Name Generator | Funny & Creative Names</title>
      </Helmet>
      <FantasyFootballHero />
      <FantasyFootballNameGenerator />
      <FantasyFootballFeatures />
      <FantasyFootballHowItWorks />
      <FantasyFootballTestimonials />
      <FantasyFootballGuide />
      <FantasyFootballSEOContent />
      <FantasyFootballFAQ />
      <FantasyFootballCallToAction />
    </>
  );
}